import React, { FC } from 'react';
import { graphql } from 'gatsby';

import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  Title,
  FaqWrapper,
  FaqTitle,
  FaqText,
} from './styled';

const Faq: FC<Queries.SeoFaqFragment> = ({ faq }) => {
  return (
    <StyledSection>
      <StyledContentBlock>
        <MainContainer>
          <Title>FAQ</Title>
          {faq?.map(f => (
            <FaqWrapper key={f?.title}>
              <FaqTitle>{f?.title}</FaqTitle>
              {f?.content?.map(p => (
                <FaqText
                  key={p}
                  dangerouslySetInnerHTML={{ __html: p || '' }}
                />
              ))}
            </FaqWrapper>
          ))}
        </MainContainer>
      </StyledContentBlock>
    </StyledSection>
  );
};

export const query = graphql`
  fragment SeoFaq on Json {
    faq {
      title
      content
    }
  }
`;

export default Faq;
